import React from 'react';
import { ClinicMasterProduct } from '../../../apis/clinic-master-products/types';
import HealtheraTable from '../../Table/Table';
import { convertClinicMasterProductsToTable, prepareLoadingData } from './utils';

interface Props {
  clinicMasterProducts: ClinicMasterProduct[];
  page: number;
  rowsPerPage: number;
  rowsPerPageOptions: number[];
  total?: number;
  isLoading: boolean;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onPageChange: (event: React.ChangeEvent<HTMLDivElement>, page: number) => void;
}

const ClinicMasterProductsTable = ({
  clinicMasterProducts,
  onRowsPerPageChange,
  onPageChange,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  total,
  isLoading
}: Props) => {
  const preparedData = isLoading ? prepareLoadingData(rowsPerPage) : convertClinicMasterProductsToTable(clinicMasterProducts);

  return (
    <HealtheraTable
      isLiveDashboard={false}
      data={preparedData}
      totalCount={total}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
      onChangePage={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      page={page}
      displayPagination
    />
  );
};
export default ClinicMasterProductsTable;
